import FastQuoteDetailsSkeleton from "features/SideMenu/skeletons/FastQuoteDetailsSkeleton";
import { useFormikContext } from "formik";
import useDeviceType from "hooks/useDeviceType";
import Tooltip from "library/Atoms/Tooltip";
import FlatBoxLayout from "library/Layouts/BoxLayout/FlatBoxLayout";
import MessageLayout from "library/Layouts/MessageLayout";
import OrderSummaryBoxLayout from "library/Layouts/OrderDetailsBoxLayout/OrderSummaryBoxLayout/OrderSummaryBoxLayout";
import { Trans, useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { retrieveContactCity, retrieveContactPaymentType } from "store/features/contact.store";
import { formatPrice } from "utility/helpers/general";

const FastQuoteDetails = () => {
  const { t } = useTranslation();
  const { isMobile } = useDeviceType();

  const city = useSelector(retrieveContactCity);
  const { isCheckoutPaymentType } = useSelector(retrieveContactPaymentType);

  const {
    values: {
      price: { price, currency, distance = null },
    },
    isSubmitting,
  } = useFormikContext();

  return (
    <div className="d-flex flex-column col-md-5 col-12 mt-md-3 mb-md-0 mb-3 pl-md-3 pr-md-0 px-0">
      {isSubmitting ? (
        <FastQuoteDetailsSkeleton />
      ) : (
        <FlatBoxLayout className="flex-wrap w-100" data-cy="fast-quote-price-details">
          <OrderSummaryBoxLayout.Line
            titleSection={t("utils.pricing.estimatedCosts")}
            contentSection={
              <>
                <Trans
                  i18nKey="utils.pricing.exclVAT"
                  tOptions={{ price: formatPrice(price, currency ?? "") }}
                  components={{ span: <span /> }}
                  defaults="<span>{{price}}</span> excl. VAT"
                />

                {isMobile && !isCheckoutPaymentType && (
                  <Tooltip color="primary">{t("newOrder.estimation.notFinalPriceMessage")}</Tooltip>
                )}
              </>
            }
          />

          {distance !== null && (
            <>
              <OrderSummaryBoxLayout.Line
                titleSection={t("newOrder.estimation.distance")}
                contentSection={t("newOrder.estimation.distanceValue", {
                  context: city,
                  distance: distance.toFixed(1),
                })}
              />
            </>
          )}
        </FlatBoxLayout>
      )}

      {!isMobile && !isCheckoutPaymentType && (
        <MessageLayout
          className="w-100 mt-3 px-0"
          labelSection={<>{t("newOrder.estimation.notFinalPriceMessage")}</>}
        />
      )}
    </div>
  );
};

export default FastQuoteDetails;
